import React from "react";
import { connect } from "react-redux";
import {Tabs, Button} from "antd";

//action imports
import { showNewAnnouncementModal } from "../../actions/AnnouncementsActions";

//component imports
import NewAnnouncement from "./subComponents/NewAnnouncement";
import ViewAnnouncements from "./subComponents/ViewAnnouncements";
import ViewScheduledAnnouncements from "./subComponents/ViewScheduledAnnouncements";

//file imports
import addCustomerArtwork from "../../assets/images/addCustomerArtwork.png";

//property declarations
const { TabPane } = Tabs;

class Announcements extends React.Component {

    constructor(props) {
        super(props);

        this.showModal = this.showModal.bind(this);
    }

    showModal = () => {
        this.props.showNewAnnouncementModal();
    };

    render() {
        return(
            <div className={"newCustomerContainer"}>
                <div className={"newCustomerArtworkBox"}>
                    <img src={addCustomerArtwork} alt="add new customer artwork" />
                </div>
                <div className={"newCustomerButtonBox"}>
                    <Button type="default" onClick={this.showModal}>
                        Add New Announcement
                    </Button>
                </div>

                <div>
                    <Tabs defaultActiveKey="1">
                        <TabPane tab="Instant Announcements" key="1">
                            <ViewAnnouncements/>
                        </TabPane>
                        <TabPane tab="Scheduled Announcements" key="2">
                            <ViewScheduledAnnouncements/>
                        </TabPane>
                    </Tabs>
                </div>
                <NewAnnouncement/>
            </div>
        );
    }
}

export default connect(null, { showNewAnnouncementModal })(Announcements);